// extracted by mini-css-extract-plugin
module.exports = {"mask":"_5D36JlxG","loader":"_5D3xDjZ8","link":"_5Di0KfkP","page":"_5D2-Es3E","logo":"_5D3Bfdel","label":"_5D2pytUs","icon":"_5DbG3s0F"};